// Practice videos are stored as YouTube/Rutube embed URLs (see AdminVideos.jsx's toEmbedUrl) -
// pull the video ID back out to use YouTube's public thumbnail image as a stand-in cover when a
// practice has no coverPhoto of its own. Rutube has no equivalent public thumbnail endpoint.
export const getVideoThumbnail = (videoUrl) => {
  if (!videoUrl || typeof videoUrl !== "string") return "";
  try {
    const url = new URL(videoUrl);
    if (url.hostname.includes("youtube.com") && url.pathname.includes("/embed/")) {
      const id = url.pathname.split("/embed/")[1]?.split("/")[0];
      if (id) return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
    }
  } catch {
    return "";
  }
  return "";
};
